import { Sheets } from "common/sheets";
export class Background {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, fileName);
        this.sprite.animationSpeed = 0.1;
    }
}
export const fileName = "배경 ";
//# sourceMappingURL=background.js.map